<template>
  <div class="d-flex">
    <!-- <v-container  class="d-flex"> -->
    <v-select
      v-model="selected"
      :items="List"
      :item-text="itemText"
      :item-value="itemValue"
      :prepend-icon="Prependicon"
      :label="Lable"
      @change="OnChange({ value: selected, datasource: DataSource,Items:List })"
      :disabled="Disabled"
    >
      <template v-slot:label>
        {{ Lable }}
        <span v-if="isRequired" class="red--text"> *</span>
      </template>
    </v-select>
    <v-btn
      v-if="showEditIcon"
      slot="append"
      color="primary"
      outlined
      small
      fab
      @click="toggleReadonly"
    >
      <v-icon color="primary"> mdi-pencil </v-icon>
    </v-btn>
  </div>
  <!-- </v-container> -->
</template>
<script>
import DataList from "@/services/dataliststore.js";
export default {
  name: "DropdownList_custom_item",
  props: [
    "Readonly",
    "showEditIcon",
    "selectedValue",
    "Lable",
    "DataSource",
    "items",
    "Prependicon",
    "itemText",
    "itemValue",
    "isRequired",
    "customItem",
  ],
  data() {
    return {
      List: [],
      type: "",
      Disabled: false,
      selected: "",
      selectedText: "",
    };
  },
  created() {
    this.getData();
    this.Disabled = this.Readonly;
    this.selected = this.selectedValue;
    if (!this.itemText) {
      this.itemText = "title";
    }
    if (!this.itemValue) {
      this.itemValue = "_id";
    }
  },
  methods: {
    async getData() {
      if(this.DataSource){
        const res = await DataList.methods.fetchData(this.DataSource);
        this.List = res;
      }
      else
      {
         this.List = this.items;
      }
      if (this.customItem && this.customItem !== "") {
        let count = this.List.length + 1;
        let newItem = { _id: count, title: this.customItem };
        this.List.push(...[newItem]);
      }
    },
    OnChange(args) {
      this.$emit("SelectedItem", args);
    },
    toggleReadonly() {
      this.Disabled = !this.Disabled;
    },
  },
};
</script>